import { useState, useEffect } from 'react';
import {
  Collapse,
  Button,
  Row,
  Col,
  Form,
  InputGroup,
  OverlayTrigger,
  Tooltip,
  Alert,
} from 'react-bootstrap';

import cx from 'classnames';

import CompareIcon from '../../../CompareIcon';

import CopyToClipboardIcon from 'components/CopyToClipboardIcon';
import { IcebergIcon } from '@tradesolution/iceberg-ui-react';

import { CompareStatus, qaCompareSimpleValue } from '../../../../utils';

import Style from '../../index.module.css';
import useLocalStorage from 'utils/hooks/useLocalStorage';
import { EnhetViewModel } from 'services/KjederegisteretAdminApi/EnhetApi/types';

interface Props {
  glnFromCr?: string;
  gln?: string;
  eierGLNNavnFromCr?: string;
  eierGLNNavn?: string;
  sentBySystem: string;
  onChange: (updatedGln: string) => void;
  enhet: EnhetViewModel;
  sentBy: string;
}

const GlnRow = (props: Props) => {
  const [isExpandRow, setIsExpandRow] = useState<boolean>(false);
  const [isUserPreferneceExpandRow, setIsUserPreferneceExpandRow] = useLocalStorage<boolean>(
    'userPreferenceGlnRowExpanded',
    false,
  );

  const [compareStatus, setCompareStatus] = useState<CompareStatus>(
    qaCompareSimpleValue(props.glnFromCr, props.gln),
  );
  const [eierGlnNavnCompareStatus, setEierGlnNavnCompareStatus] = useState<string>();

  useEffect(() => {
    if (compareStatus === 'ulik' || compareStatus === 'ny') {
      setIsExpandRow(true);
    }

    if (eierGlnNavnCompareStatus === 'ulik') {
      setIsExpandRow(true);
    }

    if (isUserPreferneceExpandRow) {
      setIsExpandRow(true);
    }

    if (props.enhet?.firma?.glnNedlagtDato) {
      setIsExpandRow(true);
    }
  }, [compareStatus, eierGlnNavnCompareStatus]);

  useEffect(() => {
    setCompareStatus(qaCompareSimpleValue(props.glnFromCr, props.gln));
  }, [props.gln, props.glnFromCr]);

  useEffect(() => {
    setEierGlnNavnCompareStatus(qaCompareSimpleValue(props.eierGLNNavn, props.eierGLNNavnFromCr));
  }, [props.eierGLNNavn, props.eierGLNNavnFromCr]);

  const handleExpandRowClick = () => {
    setIsExpandRow(!isExpandRow);
    setIsUserPreferneceExpandRow(!isExpandRow);
  };

  return (
    <>
      <div
        className={cx(Style.changeRequestRowHeaderContainer, {
          [Style.isNotExpandedRowContainer]: !isExpandRow,
        })}
        onClick={handleExpandRowClick}
      >
        <h6 className={Style.changeRequestRowHeader}>
          {!isExpandRow && <CompareIcon compareStatus={compareStatus} size="sm" />}
          <span className={Style.changeRequestRowHeaderText}>GLN </span>
        </h6>
        {isExpandRow && props.enhet?.firma?.glnNedlagtDato && (
          <span className="ms-auto me-2" style={{ display: 'inline-block' }}>
            <Form.Text className="text-muted">Gln er nedlagt</Form.Text>
          </span>
        )}
        <Button variant="link" size="sm">
          <IcebergIcon icon={isExpandRow ? 'chevron-up' : 'chevron-down'} bold />
        </Button>
      </div>
      <Collapse in={isExpandRow}>
        <div>
          <Row className={Style.formGroupRow}>
            <Col xs={12} md={5}>
              <Form.Group className={Style.formGroup}>
                <InputGroup size="sm">
                  <Form.Control readOnly value={props.glnFromCr || ''} />
                  <InputGroup.Text>
                    <CopyToClipboardIcon val={props.glnFromCr} />
                  </InputGroup.Text>
                </InputGroup>
                {props.eierGLNNavnFromCr && (
                  <Form.Text className="text-muted">
                    Eier: <strong> {props.eierGLNNavnFromCr}</strong>
                  </Form.Text>
                )}
              </Form.Group>
            </Col>
            {props.sentBySystem === 'GlnApi' ||
            props.sentBy === 'GlnSnitch' ||
            props.sentBy === 'GlnApi' ||
            props.sentBy === 'Salgsdata' ? (
              <Col xs="auto" md={2} className={Style.compareIconContainer}>
                <CompareIcon
                  compareStatus={compareStatus}
                  onClick={() => props.onChange(props.glnFromCr)}
                />
              </Col>
            ) : (
              <Col xs="auto" md={2} className={Style.compareIconContainer}>
                <CompareIcon
                  compareStatus={'ugyldig'}
                  tooltipText="Innkommende GLN kommer ikke fra GlnApi."
                />
              </Col>
            )}
            <Col xs={12} md={5}>
              <Form.Group className={Style.formGroup}>
                <InputGroup size="sm">
                  {props.enhet?.firma?.glnNedlagtDato ? (
                    <Form.Control
                      className="text-danger fw-bold"
                      value={props.gln || ''}
                      readOnly
                    />
                  ) : (
                    <Form.Control value={props.gln || ''} readOnly />
                  )}
                </InputGroup>
                {props.eierGLNNavn && (
                  <Form.Text className="text-muted">
                    Eier:
                    {eierGlnNavnCompareStatus === 'ulik' && (
                      <strong style={{ color: 'red' }}> {props.eierGLNNavn}</strong>
                    )}
                    {eierGlnNavnCompareStatus !== 'ulik' && <strong> {props.eierGLNNavn}</strong>}
                  </Form.Text>
                )}
                {/* {props.enhet?.firma?.glnNedlagtDato &&
                                    <Form.Text className="text-danger fw-bold">, Gln er nedlagt.</Form.Text>
                                } */}
              </Form.Group>
            </Col>
          </Row>
        </div>
      </Collapse>
    </>
  );
};

export default GlnRow;
